import React, { useEffect, useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from 'react-redux';
import {
  addNewTimespend,
  changeCalculationKey,
  changeCalculationThirdLevelValue,
  removeTimespend,
} from '../../store/orderReducer';
import axios from '../../api/axios';
import { MDBInput } from 'mdb-react-ui-kit';
import TablePreloader from '../UI/TablePreloader';
import Selector from '../UI/Selector';

const Step2 = () => {
  const [companyStuff, setCompanyStuff] = useState([]);
  const [stuffForSelector, setStuffForSelector] = useState([]);
  const dispatch = useDispatch();
  const calculations = useSelector(state => state.order.calculations);
  const step = useSelector(state => state.steps.step);
  const companyIdentifier = useSelector(
    state => state.users.currentUser.companyIdentifier,
  );

  const getStuff = () => {
    axios
      .get(`api/get-stuff/${companyIdentifier}`)
      .then(response => {
        setCompanyStuff(response.data);

        const transformedData = response.data.map(item => {
          return {
            label:
              item.qualification +
              ', ' +
              item.category +
              ', ' +
              item.scientific_degree,
            value: item.id,
          };
        });
        setStuffForSelector(transformedData);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getStuff();
  }, []);

  const findSallary = index => {
    if (companyStuff.length > 0 && index) {
      return companyStuff.find(item => item.id === index).salary;
    } else {
      return '-';
    }
  };

  const stuffSelectorHandle = (category, calculationIndex, stuffIndex, e) => {
    const newObl = {
      id: e.value,
      name: e.label,
    };
    dispatch(
      changeCalculationThirdLevelValue([
        category,
        calculationIndex,
        'stuff',
        stuffIndex,
        'quality',
        newObl,
      ]),
    );
    const salary = findSallary(e.value);
    dispatch(
      changeCalculationThirdLevelValue([
        category,
        calculationIndex,
        'stuff',
        stuffIndex,
        'salary',
        salary,
      ]),
    );
  };

  return (
    <div className={step === 2 ? 'block' : 'hidden'}>
      <div
        className='flex w-full mb-4 rounded-lg bg-orange-100 p-3 text-base'
        role='alert'
      >
        <div className='flex items-center justify-center'>
          <InformationCircleIcon className='w-6 h-6 mr-4' />
        </div>
        <div>
          Заповніть часові втирати лікарів, які були внесені в відповідну{' '}
          <span className='text-blue-600'>форму</span>
        </div>
      </div>
      {calculations ? (
        Object.keys(calculations).map((category, categoryIndex) => (
          <div key={`category_${category}_${categoryIndex}`}>
            <div className='bg-gray-200 rounded text-xl underline font-bold text-center mb-3 py-2'>
              {category}
            </div>
            {calculations[category].map(calculation => (
              <div key={`calculation_${calculation.id}`} className=''>
                <div className='flex items-center mb-4'>
                  <div className='w-1/2'>
                    <div className='text-lg font-bold'>{calculation.name}</div>
                    <div className='mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]'>
                      <input
                        className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                        type='checkbox'
                        value=''
                        id='checkboxDefault'
                      />
                      <label
                        className='text-sm inline-block pl-[0.15rem] hover:cursor-pointer'
                        htmlFor='checkboxDefault'
                      >
                        Додати в розрахунок акт хронометражу
                      </label>
                    </div>
                  </div>
                  <div className='w-1/2 flex items-center'></div>
                  <div className='w-[100px]'>
                    <MDBInput
                      type='number'
                      id='calculationName'
                      label='Премія, %'
                      step='1'
                      value={calculation.calculation.bonus}
                      onChange={e =>
                        dispatch(
                          changeCalculationKey([
                            category,
                            calculation.id,
                            'bonus',
                            e.target.value,
                          ]),
                        )
                      }
                    />
                  </div>
                </div>
                {calculation.calculation.stuff.map((stuff, stuffIndex) => (
                  <div
                    key={`stuff_${stuff.quality}_${stuffIndex}`}
                    className='flex items-center mb-2 gap-x-4'
                  >
                    <div className='w-full'>
                      <Selector
                        options={stuffForSelector}
                        placeholder='Кваліфікація'
                        value={
                          stuffForSelector.find(
                            companyStuff =>
                              companyStuff.label === stuff.quality.name,
                          ) || null
                        }
                        onChange={e =>
                          stuffSelectorHandle(
                            category,
                            calculation.id,
                            stuffIndex,
                            e,
                          )
                        }
                        isSearchable
                      />
                      {!stuffForSelector.find(
                        companyStuff =>
                          companyStuff.label === stuff.quality.name,
                      ) && (
                        <div className='flex w-full mt-1 rounded-lg bg-red-100 p-2 text-base'>
                          <small className='pb-0'>
                            Кваліфікація з шаблону "{stuff.quality.name}" -
                            відсутня в вашому штатному розкладі. Будь-ласка,
                            виберіть кваліфікацію зі свого штатного розкладу
                          </small>
                        </div>
                      )}
                    </div>
                    <div className='w-48 text-center'>
                      <div className='text-sm'>З/П</div>
                      <div className='text-sm font-bold'>
                        {findSallary(stuff.quality.id)}
                      </div>
                    </div>
                    <div className='w-96'>
                      <MDBInput
                        type='number'
                        label='Час виконання, хв'
                        value={stuff.timeSpend}
                        onChange={e =>
                          dispatch(
                            changeCalculationThirdLevelValue([
                              category,
                              calculation.id,
                              'stuff',
                              stuffIndex,
                              'timeSpend',
                              parseInt(e.target.value, 10),
                            ]),
                          )
                        }
                      />
                    </div>
                    <div className='w-96'>
                      <MDBInput
                        type='number'
                        id='calculationName'
                        label='% за умови праці'
                        step='0.01'
                        value={stuff.conditionPercent}
                        onChange={e =>
                          dispatch(
                            changeCalculationThirdLevelValue([
                              category,
                              calculation.id,
                              'stuff',
                              stuffIndex,
                              'conditionPercent',
                              e.target.value,
                            ]),
                          )
                        }
                      />
                    </div>
                    <div className='w-96'>
                      <Selector
                        options={[
                          { label: 6, value: 6 },
                          {
                            label: 6.5,
                            value: 6.5,
                          },
                          { label: 7, value: 7 },
                          {
                            label: 7.5,
                            value: 7.5,
                          },
                          { label: 8, value: 8 },
                          {
                            label: 8.5,
                            value: 8.5,
                          },
                          { label: 9, value: 9 },
                          {
                            label: 10,
                            value: 10,
                          },
                          {
                            label: 12,
                            value: 12,
                          },
                        ]}
                        placeholder='Кваліфікація'
                        value={{
                          label: stuff.workingDay,
                          value: stuff.workingDay,
                        }}
                        onChange={e =>
                          dispatch(
                            changeCalculationThirdLevelValue([
                              category,
                              calculation.id,
                              'stuff',
                              stuffIndex,
                              'workingDay',
                              e.value,
                            ]),
                          )
                        }
                      />
                    </div>
                    <div className='w-48 text-center'>
                      <div className='font-bold'>
                        ={' '}
                        {stuff.salary > 0
                          ? (
                              (stuff.salary / 21 / 60) *
                              stuff.workingDay *
                              (stuff.conditionPercent / 100 + 1) *
                              (calculation.calculation.bonus / 100 + 1)
                            ).toFixed(2)
                          : 0}
                      </div>
                    </div>
                    <div className='w-max'>
                      <TrashIcon
                        onClick={() =>
                          dispatch(
                            removeTimespend([
                              category,
                              calculation.id,
                              stuffIndex,
                            ]),
                          )
                        }
                        className='w-6 h-6 text-danger  cursor-pointer hover:scale-125 transition duration-500 ease-in-out'
                      />
                    </div>
                  </div>
                ))}
                <div className='flex justify-end'>
                  <button
                    type='button'
                    onClick={() =>
                      dispatch(addNewTimespend([category, calculation.id]))
                    }
                    className='inline-block rounded bg-success px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-success-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-success-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-success-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]'
                  >
                    Додати часову витрату
                  </button>
                </div>
                {calculations[category].length > 1 &&
                calculation.id + 1 !== calculations[category].length ? (
                  <hr
                    className='h-px mt-8 mb-4 bg-gray-600 border-0 dark:bg-gray-700'
                    onClick={() =>
                      console.log(
                        calculation.id + ' ' + category.calculations.length,
                      )
                    }
                  />
                ) : (
                  <div className='mb-6' />
                )}
              </div>
            ))}
          </div>
        ))
      ) : (
        <TablePreloader />
      )}
    </div>
  );
};

export default Step2;
